export const XLSX_URL = "/api/ui";